import React, { useEffect, useRef, useState } from 'react'
import { AiOutlineDown } from 'react-icons/ai'
import CourseSubSectionAccordion from './CourseSubSectionAccordion'

export default function CourseAccordionBar({course,isActive,handleActive}) {

    const currentEl=useRef()
    const [active,setActive]=useState(false)
    const [subSectionHeight,setSubSectionHeight]=useState(0)

    useEffect(()=>{
        setActive(isActive.includes(course._id))
    },[isActive])

    useEffect(()=>{
        setSubSectionHeight(active ? currentEl.current.scrollHeight :0)
    },[active])



  return (
    <div className="overflow-hidden border border-solid border-richblack-600 bg-richblack-700 text-richblack-5 last:mb-0">
        {/* Section  */}
        <div>
            {/* section inside div */}
            <div className='flex justify-between items-start  cursor-pointer bg-opacity-20 px-7 py-6 transition-[0.3s]' onClick={()=>handleActive(course._id)}>
                <div className='flex items-center gap-2'>
                {/* icon */}
                <i className={isActive.includes(course._id)?"rotate-180":"rotate-0"}>
                    <AiOutlineDown/>
                </i>
                <p>{course.sectionName}</p>
                </div>

                <div className='text-yellow-25 space-x-4'>
                    <span>{`${course.subSection.length||0}`} lectures</span>
                </div>

            </div>
        </div>
        {/* subSection  */}
        <div ref={currentEl} className='relative h-0 overflow-hidden bg-richblack-900 transition-[height] duration-[0.35s] ease-[ease]' style={{height:subSectionHeight}}>
            <div className='text-textHead flex flex-col gap-2 px-7 py-6 font-semibold'>
                {
                    course?.subSection?.map((subSec,index)=>(
                        <CourseSubSectionAccordion subSec={subSec} key={index}/>
                    ))
                }

            </div>
        </div>

      
    </div>
  )
}
